import { render, staticRenderFns } from "./TipoAcaoTabela.vue?vue&type=template&id=0615e58f&lang=html&"
import script from "./TipoAcaoTabela.vue?vue&type=script&lang=js&"
export * from "./TipoAcaoTabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/tipo-acao/TipoAcaoTabela.vue
// module id = 1525
// module chunks = 28